import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../website/components/Header";
import Footer from "../website/components/Footer";
import TopStrip from "../website/components/TopStrip";

function loadCSS(href, id) {
  return new Promise((resolve) => {
    if (document.getElementById(id)) {
      resolve();
      return;
    }
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.id = id;
    link.onload = resolve;
    link.onerror = resolve;
    document.head.appendChild(link);
  });
}

function removeCSS(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

function loadScript(src, id) {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.id = id;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

function removeScript(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

export default function WebsiteLayout() {
  const [isLoading, setIsLoading] = useState(true);
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setShowBackToTop(window.scrollY > 500);
    }
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  useEffect(() => {
    let isMounted = true;

    async function loadAssets() {
      await Promise.all([
        loadCSS(
          "https://cdnjs.cloudflare.com/ajax/libs/bootstrap/4.6.2/css/bootstrap.min.css",
          "bootstrap-css",
        ),
        loadCSS(
          "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css",
          "fontawesome-css",
        ),
        loadCSS("/assets/website/css/style.css", "website-css"),
      ]);

      try {
        await loadScript(
          "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js",
          "jquery-js",
        );
        await loadScript(
          "https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.16.1/umd/popper.min.js",
          "popper-js",
        );
        await loadScript(
          "https://cdnjs.cloudflare.com/ajax/libs/bootstrap/4.6.2/js/bootstrap.min.js",
          "bootstrap-js",
        );
        await loadScript("/assets/website/js/main.js", "website-main-js");
      } catch (err) {
        console.error("Website script load error:", err);
      }

      if (isMounted) {
        setIsLoading(false);
      }
    }

    loadAssets();

    return () => {
      isMounted = false;
      removeCSS("bootstrap-css");
      removeCSS("fontawesome-css");
      removeCSS("website-css");
      removeScript("jquery-js");
      removeScript("popper-js");
      removeScript("bootstrap-js");
      removeScript("website-main-js");
    };
  }, []);

  if (isLoading) {
    return (
      <div className="website-loader">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <>
      <TopStrip />
      <Header />
      <Outlet />
      <Footer />
      <a
        href="https://wa.me/7004654910?text=Hi%2C%20I%20saw%20your%20website%2C%20I%27m%20interested%20in%20your%20courses.%20Could%20you%20share%20more%20details%3F"
        className="wa-float"
        aria-label="Chat on WhatsApp"
        target="_blank"
        rel="noopener"
      >
        <i className="fa-brands fa-whatsapp" />
      </a>
      <button
        id="backToTop"
        aria-label="Back to top"
        className={showBackToTop ? "show" : ""}
        onClick={scrollToTop}
      >
        <i className="fa-solid fa-arrow-up" />
      </button>
    </>
  );
}
